import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { auth } = useAuth();

  if (!auth) {
    // if we know a domain we want to send the user back to the login page with
    // that query string so it remains visible after a logout / forced redirect.
    const domain = localStorage.getItem('domain');
    const to = domain ? `/login?domain=${encodeURIComponent(domain)}` : '/login';
    return <Navigate to={to} replace />;
  }

  return children;
};

export default ProtectedRoute;